import {Dialog as LuffyDialog} from '@baidu/luffy-comp-dialog';
import {DialogProps as LuffyDialogProps} from '@baidu/luffy/types';

export {DialogBody, DialogFoot} from '@baidu/luffy-comp-dialog';

export interface DialogProps extends LuffyDialogProps {
    showCancelButton?: boolean;
    showConfirmButton?: boolean;
}

export enum DialogSize {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
}

export default function Dialog(props: DialogProps) {
    const {
        showCancelButton, showConfirmButton,
        maskCancel, actions, osType,
        children, ...dialogProps
    } = props;

    let dialogActions = actions;
    let dialogMaskCancel = maskCancel;
    if (!showCancelButton && !showConfirmButton && !actions) {
        dialogActions = (<div />);
        if (typeof maskCancel === 'undefined') {
            dialogMaskCancel = true;
        }
    }
    return (
        <LuffyDialog
            actions={dialogActions}
            maskCancel={dialogMaskCancel}
            osType={'windows'}
            {...dialogProps}
        >
            {children}
        </LuffyDialog>
    );
}
